import { observable, Observable, useMemoizedObservable, useObservable } from 'micro-observables';
import { Signal } from 'micro-signals';
import { v4 } from 'uuid';
import { useRef, useState, useEffect, useCallback } from 'react';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var runtime_1 = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined$1; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  define(Gp, "constructor", GeneratorFunctionPrototype);
  define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined$1) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined$1;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined$1;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined$1;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined$1, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined$1;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined$1;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined$1;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined$1;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined$1;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   module.exports 
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}
});

function presentItems(refItems, paginatedItems, deletedItems, primaryKey) {
  var usedKey = primaryKey != null ? primaryKey : "id";
  return paginatedItems ? _extends({}, paginatedItems, {
    content: paginatedItems.content.map(function (item) {
      var _refItems$get;

      return (_refItems$get = refItems.get(item[usedKey])) != null ? _refItems$get : deletedItems.has(item[usedKey]) ? null : item;
    }).filter(function (c) {
      return !!c;
    })
  }) : null;
}
function retrieveReference(property, i, itemsMap, arrayPath, deletedProperties, primaryKey) {
  var _extends3;

  var key = arrayPath[i];

  if (i >= arrayPath.length - 1) {
    var _itemsMap$get, _extends2;

    return _extends({}, property, (_extends2 = {}, _extends2[key] = property[key] && ((_itemsMap$get = itemsMap.get(property[key][primaryKey != null ? primaryKey : "id"])) != null ? _itemsMap$get : deletedProperties.has(property[key][primaryKey != null ? primaryKey : "id"]) ? null : property[key]), _extends2));
  }

  return _extends({}, property, (_extends3 = {}, _extends3[key] = property[key] && retrieveReference(property[key], i + 1, itemsMap, arrayPath, deletedProperties, primaryKey), _extends3));
}

var Store = /*#__PURE__*/function () {
  function Store(_fetch, primaryKey) {
    if (primaryKey === void 0) {
      primaryKey = "id";
    }

    this._fetch = _fetch;
    this.primaryKey = primaryKey;
    this._itemsById = observable(new Map());
    this._onNewElements = new Signal();
    this.referencedProperties = [];
    this._deletedProperties = observable(new Set());
    this.onDelete = new Signal();
    this.onUpdateAttemptOnNonExistingItem = new Signal();
  }

  var _proto = Store.prototype;

  _proto.bindProperty = function bindProperty(path, referenceStore) {
    var _this = this;

    this.referencedProperties.push({
      path: path,
      store: referenceStore
    });

    this._onNewElements.add(function (_ref) {
      var updateId = _ref.updateId,
          content = _ref.content;

      if (updateId === path) {
        // Ensure we don't go in an infinite loop
        return;
      }

      var keys = path.split(".");

      var getProperty = function getProperty(property, i) {
        var key = keys[i];
        var subProperty = property[key];

        if (i >= keys.length - 1 || subProperty === undefined) {
          return subProperty;
        }

        return getProperty(subProperty, i + 1);
      };

      referenceStore.onDelete.add(function (id) {
        _this._deletedProperties.update(function (s) {
          return new Set(s).add(id);
        });
      });
      referenceStore.merge(content.map(function (item) {
        return getProperty(item, 0);
      }).filter(function (v) {
        return v !== undefined;
      }), path);
    });

    return this;
  };

  _proto.presentProperty = function presentProperty(path, referenceStore) {
    var _this2 = this;

    this.referencedProperties.push({
      path: path,
      store: referenceStore
    });

    this._onNewElements.add(function (_ref2) {
      var updateId = _ref2.updateId,
          content = _ref2.content;

      if (updateId === path) {
        // Ensure we don't go in an infinite loop
        return;
      }

      var keys = path.split(".");

      var getProperty = function getProperty(property, i) {
        var key = keys[i];
        var subProperty = property[key];

        if (i >= keys.length - 1 || subProperty === undefined) {
          return subProperty;
        }

        return getProperty(subProperty, i + 1);
      };

      referenceStore.onDelete.add(function (id) {
        _this2._deletedProperties.update(function (s) {
          return new Set(s).add(id);
        });
      });
      referenceStore.batchUpdateProperties(content.map(function (item) {
        return getProperty(item, 0);
      }).filter(function (v) {
        return v !== undefined;
      }));
    });

    return this;
  };

  _proto.getObservable = function getObservable(id) {
    return this.items.select(function (items) {
      var _items$get;

      return (_items$get = items.get(id)) != null ? _items$get : null;
    });
  };

  _proto.save = function save(item) {
    var _this3 = this;

    this._itemsById.update(function (items) {
      return new Map(items).set(item[_this3.primaryKey], item);
    });

    this._onNewElements.dispatch({
      updateId: "save",
      content: [item]
    });
  };

  _proto.merge = function merge(items, __updateId) {
    var _this4 = this;

    if (__updateId === void 0) {
      __updateId = v4();
    }

    this._itemsById.update(function (current) {
      return new Map([].concat(_toConsumableArray(current), _toConsumableArray(items.map(function (item) {
        return [item[_this4.primaryKey], _extends({}, current.get(item[_this4.primaryKey]), item)];
      }))));
    });

    this._onNewElements.dispatch({
      updateId: __updateId,
      content: items
    });
  };

  _proto.updateProperties = function updateProperties(properties) {
    this.update(properties[this.primaryKey], function (current) {
      return _extends({}, current, properties);
    });
  };

  _proto.batchUpdateProperties = function batchUpdateProperties(items) {
    var _this5 = this;

    this._itemsById.update(function (current) {
      var newMap = new Map(current);
      items.forEach(function (item) {
        var current = newMap.get(item[_this5.primaryKey]);

        if (current) {
          newMap.set(item[_this5.primaryKey], _extends({}, current, item));
        }
      });
      return newMap;
    });
  };

  _proto.update = function update(key, updater) {
    var _this6 = this;

    var item = this._itemsById.get().get(key);

    if (item) {
      this._itemsById.update(function (items) {
        return new Map(items).set(item[_this6.primaryKey], updater(item));
      });
    } else {
      this.onUpdateAttemptOnNonExistingItem.dispatch({
        key: key,
        updater: updater
      });
    }
  };

  _proto.remove = function remove(key) {
    this._itemsById.update(function (items) {
      var res = new Map(items);
      res["delete"](key);
      return res;
    });

    this.onDelete.dispatch(key);
  };

  _proto.fetch = /*#__PURE__*/function () {
    var _fetch2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(id) {
      var result;
      return runtime_1.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this._fetch(id);

            case 2:
              result = _context.sent;

              this._itemsById.update(function (current) {
                return new Map(current).set(id, result);
              });

              this._onNewElements.dispatch({
                updateId: "fetch",
                content: [result]
              });

              return _context.abrupt("return", this.items.get().get(id));

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function fetch(_x) {
      return _fetch2.apply(this, arguments);
    }

    return fetch;
  }();

  _proto.clear = function clear() {
    this._itemsById.set(new Map());
  };

  _createClass(Store, [{
    key: "items",
    get: function get() {
      var _this7 = this;

      if (this.referencedProperties.length > 0) {
        return Observable.select([this._itemsById, this._deletedProperties].concat(_toConsumableArray(this.referencedProperties.map(function (p) {
          return p.store.items;
        }))), function (items, deleted) {
          var newItems = _toConsumableArray(items);

          for (var _len = arguments.length, subItems = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
            subItems[_key - 2] = arguments[_key];
          }

          var _loop = function _loop() {
            var _step$value = _step.value,
                j = _step$value[0],
                subItemsValues = _step$value[1];

            var keys = _this7.referencedProperties[j].path.split(".");

            newItems = newItems.map(function (_ref3) {
              var k = _ref3[0],
                  v = _ref3[1];
              return [k, retrieveReference(v, 0, subItemsValues, keys, deleted, _this7.referencedProperties[j].store.primaryKey)];
            });
          };

          for (var _iterator = _createForOfIteratorHelperLoose(subItems.entries()), _step; !(_step = _iterator()).done;) {
            _loop();
          }

          return new Map(newItems);
        });
      }

      return this._itemsById.readOnly();
    }
  }]);

  return Store;
}();

var PaginatedStore = /*#__PURE__*/function () {
  function PaginatedStore(_fetchList) {
    this._fetchList = _fetchList;
    this._paginatedItems = observable(null);
    this._deletedItems = observable(new Set());
    this.fetching = observable(false);
    this.fetchingMore = observable(false);
  }

  var _proto = PaginatedStore.prototype;

  _proto.present = function present(store) {
    var _this = this;

    this._referenceStore = store;

    this._referenceStore.onDelete.add(function (id) {
      _this._deletedItems.update(function (s) {
        return new Set(s).add(id);
      });
    });

    this._referenceStore.onUpdateAttemptOnNonExistingItem.add(function (_ref) {
      var key = _ref.key,
          updater = _ref.updater;

      _this._paginatedItems.update(function (items) {
        if (!items) {
          return null;
        }

        var newItems = _extends({}, items, {
          content: items.content.map(function (item) {
            try {
              if (item[_this._referenceStore.primaryKey] === key) {
                return updater(item);
              }

              return item;
            } catch (e) {
              return item;
            }
          })
        });

        return newItems;
      });
    });

    this._paginatedItems.subscribe(function (data) {
      if (data === null) {
        return;
      }

      store == null ? void 0 : store.batchUpdateProperties(data.content);
    });

    return this;
  };

  _proto.bind = function bind(store) {
    var _this2 = this;

    this._referenceStore = store;

    this._referenceStore.onDelete.add(function (id) {
      _this2._deletedItems.update(function (s) {
        return new Set(s).add(id);
      });
    });

    this._paginatedItems.subscribe(function (data) {
      if (data === null) {
        return;
      }

      store == null ? void 0 : store.merge(data.content);
    });

    return this;
  };

  _proto.list = /*#__PURE__*/function () {
    var _list = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee() {
      var result;
      return runtime_1.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!this.fetching.get()) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              this.fetching.set(true);
              _context.prev = 3;
              _context.next = 6;
              return this._fetchList(0);

            case 6:
              result = _context.sent;

              this._paginatedItems.set(result);

            case 8:
              _context.prev = 8;
              this.fetching.set(false);
              return _context.finish(8);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[3,, 8, 11]]);
    }));

    function list() {
      return _list.apply(this, arguments);
    }

    return list;
  }();

  _proto.listMore = /*#__PURE__*/function () {
    var _listMore = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee2() {
      var currentItems, newItems;
      return runtime_1.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(this.fetching.get() || this.fetchingMore.get())) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              currentItems = this._paginatedItems.get();

              if (currentItems) {
                _context2.next = 5;
                break;
              }

              return _context2.abrupt("return", this.list());

            case 5:
              _context2.prev = 5;
              this.fetchingMore.set(true);
              _context2.next = 9;
              return this._fetchList(currentItems.page + 1);

            case 9:
              newItems = _context2.sent;

              this._paginatedItems.set(_extends({}, newItems, {
                content: [].concat(_toConsumableArray(currentItems.content), _toConsumableArray(newItems.content))
              }));

            case 11:
              _context2.prev = 11;
              this.fetchingMore.set(false);
              return _context2.finish(11);

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this, [[5,, 11, 14]]);
    }));

    function listMore() {
      return _listMore.apply(this, arguments);
    }

    return listMore;
  }();

  _proto.clear = function clear() {
    this._paginatedItems.set(null);
  };

  _createClass(PaginatedStore, [{
    key: "items",
    get: function get() {
      var _this3 = this;

      if (!this._referenceStore) {
        return this._paginatedItems;
      }

      return Observable.select([this._referenceStore.items, this._paginatedItems, this._deletedItems], function (mapped, listed, deleted) {
        var _this3$_referenceStor;

        return presentItems(mapped, listed, deleted, (_this3$_referenceStor = _this3._referenceStore) == null ? void 0 : _this3$_referenceStor.primaryKey);
      });
    }
  }]);

  return PaginatedStore;
}();

var MappedStore = /*#__PURE__*/function () {
  function MappedStore(_fetchList) {
    this._fetchList = _fetchList;
    this._mappedItems = observable(new Map());
    this._deletedItems = observable(new Set());
    this.fetching = observable(new Set());
    this.fetchingMore = observable(new Set());
    this.onChange = new Signal();
  }

  var _proto = MappedStore.prototype;

  _proto.getFetching = function getFetching(id) {
    return this.fetching.select(function (keys) {
      return keys.has(id);
    });
  };

  _proto.getFetchingMore = function getFetchingMore(id) {
    return this.fetchingMore.select(function (keys) {
      return keys.has(id);
    });
  };

  _proto.present = function present(store) {
    var _this = this;

    this._referenceStore = store;

    this._referenceStore.onDelete.add(function (id) {
      _this._deletedItems.update(function (s) {
        return new Set(s).add(id);
      });
    });

    this.onChange.add(function (_ref) {
      var data = _ref.data;

      if (data === null) {
        return;
      }

      store == null ? void 0 : store.batchUpdateProperties(data.content);
    });
    return this;
  };

  _proto.bind = function bind(store) {
    var _this2 = this;

    this._referenceStore = store;

    this._referenceStore.onDelete.add(function (id) {
      _this2._deletedItems.update(function (s) {
        return new Set(s).add(id);
      });
    });

    this.onChange.add(function (_ref2) {
      var data = _ref2.data;

      if (data === null) {
        return;
      }

      store == null ? void 0 : store.merge(data.content);
    });
    return this;
  };

  _proto.getObservableItems = function getObservableItems(key) {
    var _this3 = this;

    var observableItems = this._mappedItems.select(function (items) {
      var _items$get;

      return (_items$get = items.get(key)) != null ? _items$get : null;
    });

    if (!this._referenceStore) {
      return observableItems;
    }

    return Observable.select([this._referenceStore.items, observableItems, this._deletedItems], function (mapped, listed, deleted) {
      var _this3$_referenceStor;

      return presentItems(mapped, listed, deleted, (_this3$_referenceStor = _this3._referenceStore) == null ? void 0 : _this3$_referenceStor.primaryKey);
    });
  };

  _proto.list = /*#__PURE__*/function () {
    var _list = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(id) {
      var result;
      return runtime_1.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!this.fetching.get().has(id)) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              this.fetching.update(function (current) {
                return new Set(current).add(id);
              });
              _context.prev = 3;
              _context.next = 6;
              return this._fetchList(id, 0);

            case 6:
              result = _context.sent;

              this._mappedItems.update(function (items) {
                return new Map(items).set(id, result);
              });

              this.dispatchChange(id);

            case 9:
              _context.prev = 9;
              this.fetching.update(function (current) {
                var newSet = new Set(current);
                newSet["delete"](id);
                return newSet;
              });
              return _context.finish(9);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[3,, 9, 12]]);
    }));

    function list(_x) {
      return _list.apply(this, arguments);
    }

    return list;
  }();

  _proto.listMore = /*#__PURE__*/function () {
    var _listMore = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee2(id) {
      var currentItems, newItems;
      return runtime_1.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(this.fetching.get().has(id) || this.fetchingMore.get().has(id))) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              currentItems = this._mappedItems.get().get(id);

              if (currentItems) {
                _context2.next = 5;
                break;
              }

              return _context2.abrupt("return", this.list(id));

            case 5:
              _context2.prev = 5;
              _context2.next = 8;
              return this._fetchList(id, currentItems.page + 1);

            case 8:
              newItems = _context2.sent;

              this._mappedItems.update(function (items) {
                return new Map(items).set(id, _extends({}, newItems, {
                  content: [].concat(_toConsumableArray(currentItems.content), _toConsumableArray(newItems.content))
                }));
              });

              this.dispatchChange(id);

            case 11:
              _context2.prev = 11;
              this.fetching.update(function (current) {
                var newSet = new Set(current);
                newSet["delete"](id);
                return newSet;
              });
              return _context2.finish(11);

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this, [[5,, 11, 14]]);
    }));

    function listMore(_x2) {
      return _listMore.apply(this, arguments);
    }

    return listMore;
  }();

  _proto.dispatchChange = function dispatchChange(id) {
    var _this$_mappedItems$ge;

    this.onChange.dispatch({
      id: id,
      data: (_this$_mappedItems$ge = this._mappedItems.get().get(id)) != null ? _this$_mappedItems$ge : null
    });
  };

  _proto.clear = function clear() {
    this._mappedItems.set(new Map());
  };

  return MappedStore;
}();

var FetchStrategy;

(function (FetchStrategy) {
  FetchStrategy["Always"] = "always";
  FetchStrategy["Never"] = "never";
  FetchStrategy["First"] = "first";
  FetchStrategy["Once"] = "once";
})(FetchStrategy || (FetchStrategy = {}));

function useStore(id, store, fetchStrategy, additionalDeps) {
  if (fetchStrategy === void 0) {
    fetchStrategy = FetchStrategy.Always;
  }

  if (additionalDeps === void 0) {
    additionalDeps = [];
  }

  var hasFetched = useRef(false);
  var result = useMemoizedObservable(function () {
    return store.getObservable(id || "");
  }, [id]);

  var _useState = useState(!result && !!id),
      loading = _useState[0],
      setLoading = _useState[1];

  var _useState2 = useState(null),
      error = _useState2[0],
      setError = _useState2[1];

  useEffect(function () {
    if (!shouldFetch(fetchStrategy, result !== null, hasFetched.current) || !id) {
      return;
    }

    setLoading(true);
    setError(null);
    hasFetched.current = true;
    store.fetch(id)["catch"](function (e) {
      return setError(e);
    })["finally"](function () {
      return setLoading(false);
    });
  }, [id, fetchStrategy, store].concat(_toConsumableArray(additionalDeps)));
  return {
    result: result,
    loading: loading,
    error: error
  };
}
function usePaginatedStore(paginatedStore, fetchStrategy, additionalDeps) {
  if (fetchStrategy === void 0) {
    fetchStrategy = FetchStrategy.Always;
  }

  if (additionalDeps === void 0) {
    additionalDeps = [];
  }

  var loading = useObservable(paginatedStore.fetching);
  var moreLoading = useObservable(paginatedStore.fetchingMore);
  return _extends({
    loading: loading,
    moreLoading: moreLoading
  }, useObservablePaginatedData(paginatedStore.items, function () {
    return paginatedStore.list();
  }, function () {
    return paginatedStore.listMore();
  }, fetchStrategy, [paginatedStore].concat(_toConsumableArray(additionalDeps))));
}
function useMappedStore(id, mappedStore, fetchStrategy, additionalDeps) {
  if (fetchStrategy === void 0) {
    fetchStrategy = FetchStrategy.Always;
  }

  if (additionalDeps === void 0) {
    additionalDeps = [];
  }

  var loading = useMemoizedObservable(function () {
    return mappedStore.getFetching(id || "");
  }, [id]);
  var moreLoading = useMemoizedObservable(function () {
    return mappedStore.getFetchingMore(id || "");
  }, [id]);
  return _extends({
    loading: loading,
    moreLoading: moreLoading
  }, useObservablePaginatedData(mappedStore.getObservableItems(id || ""), function () {
    return mappedStore.list(id || "");
  }, function () {
    return mappedStore.listMore(id || "");
  }, id ? fetchStrategy : FetchStrategy.Never, [id, mappedStore].concat(_toConsumableArray(additionalDeps))));
}
function useObservablePaginatedData(observableData, list, listMoreData, fetchStrategy, deps) {
  var _data$content;

  if (fetchStrategy === void 0) {
    fetchStrategy = FetchStrategy.Always;
  }

  var hasFetched = useRef(false);

  var _useState3 = useState(null),
      error = _useState3[0],
      setError = _useState3[1];

  var data = useMemoizedObservable(function () {
    return observableData;
  }, deps);
  var result = (_data$content = data == null ? void 0 : data.content) != null ? _data$content : [];
  var totalPages = data == null ? void 0 : data.totalPages;
  var totalSize = data == null ? void 0 : data.totalSize;
  var lastPage = totalPages !== undefined && data !== null && data.page >= totalPages - 1;
  useEffect(function () {
    if (!shouldFetch(fetchStrategy, data !== null, hasFetched.current)) {
      return;
    }

    hasFetched.current = true;
    setError(null);
    list()["catch"](function (e) {
      return setError(e);
    });
  }, [].concat(_toConsumableArray(deps), [fetchStrategy]));
  var listMore = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee() {
    return runtime_1.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(!totalPages || !data || lastPage)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return");

          case 2:
            _context.next = 4;
            return listMoreData();

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [totalPages, data, lastPage].concat(_toConsumableArray(deps)));
  return {
    result: result,
    error: error,
    totalPages: totalPages,
    totalSize: totalSize,
    lastPage: lastPage,
    list: list,
    listMore: listMore
  };
}

function shouldFetch(strategy, hasResult, hasFetched) {
  if (strategy === FetchStrategy.Never) {
    return false;
  }

  if (strategy === FetchStrategy.First && hasResult) {
    return false;
  }

  if (strategy === FetchStrategy.Once && hasFetched) {
    return false;
  }

  return true;
}

export { FetchStrategy, MappedStore, PaginatedStore, Store, useMappedStore, useObservablePaginatedData, usePaginatedStore, useStore };
//# sourceMappingURL=micro-stores.esm.js.map
